import { contractsService } from '@/services/ContractsService'

export const actions = {
  getContract: async ({ commit }, params) => {
    return contractsService.getContracts(params).then(res => {
      commit('SET_CONTRACT', res.data)
      return res
    })
  }
}
